import React from 'react';
import LinkedIn from '../images/linkedin.png';
import GitHub from '../images/github.png';
import CodeWars from '../images/codewars.png'

export default function Links() {
    const style = {
        paragraph: {
            fontSize: "18px",
            textAlign: "center"
        },
        aboutdiv: {
            margin: "0 auto",
            width: "75%",
            border: "1px solid black",
            borderRadius: "5px",
            backgroundColor: "white",
            padding: "20px"
        },
        overall: {
            backgroundColor: "#0b486b",
            height: "auto",
            minHeight: "80vh",
            padding: "50px 0"
        },
        link: {
            textDecoration: "none"
        },
        title: {
            fontSize: "32px",
            margin: "4px",
            textAlign: "center"
        },
        linkdiv: {
            width: "60%",
            margin: "0 auto"
        },
        linkspan: {
            textDecoration: "none",
            color: "black"
        },
        text: {
            display: "inline-block",
            marginLeft: "5px"
        }
    }
    return (
        <div style={style.overall}>
            <div style={style.aboutdiv}>
                <h2 style={style.title}>Links</h2>
                <div style={style.linkdiv}>
                    <p style={style.paragraph}>
                        <a href="https://www.linkedin.com/in/michaelipdev/" target="_blank" style={style.linkspan}><img src={LinkedIn} /><span style={style.text}>michaelipdev</span></a>
                    </p>
                    <p style={style.paragraph}>
                        <a href="https://github.com/kingmikeip" target="_blank" style={style.linkspan}><img src={GitHub} /><span style={style.text}>kingmikeip</span></a>
                    </p>
                    <p style={style.paragraph}>
                        <a href="https://www.codewars.com/users/kingmikeip" target="_blank" style={style.linkspan}><img src={CodeWars} /><span style={style.text}>kingmikeip</span></a>
                    </p>
                </div>

            </div>

        </div>
    )
}